import numeral from 'numeral'

export default function dniFormatter(value) {
    let parsedValue = numeral(numeral(value).value()).format('0,0')
    return parsedValue
}